import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["rightText", "leftText", "onToggle", "isChecked", "highlightSelection", "disabled"];
import React from 'react';
import styled from 'styled-components';
import { Typography, Switch } from '@material-ui/core';
const SwitchDiv = styled.div.withConfig({
  displayName: "ToggleSwitch__SwitchDiv",
  componentId: "sc-1bq47n6-0"
})(["margin-left:10px;margin-right:10px;display:flex;align-items:center;"]);
/**
 * @component
 * Basic, un-nested styled list. Pass messageKeys array to limit which  messages are
 * rendered.
 */

export const ToggleSwitch = _ref => {
  let {
    rightText,
    leftText,
    onToggle,
    isChecked,
    highlightSelection,
    disabled
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const selectedStyle = {
    textDecoration: 'underline',
    fontWeight: '600'
  };
  const negativeStyle = highlightSelection && isChecked && {
    opacity: '50%'
  } || selectedStyle;
  const positiveStyle = highlightSelection && !isChecked && {
    opacity: '50%'
  } || selectedStyle;
  return /*#__PURE__*/React.createElement(SwitchDiv, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: negativeStyle
  }, rightText), /*#__PURE__*/React.createElement(Switch, {
    checked: isChecked,
    size: "small",
    onChange: event => onToggle(event.target.checked),
    name: "measure",
    color: "primary",
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: positiveStyle
  }, leftText));
};
export default ToggleSwitch;